import { indexItems } from '@/mocks/homepage';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            内容分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            八大内容频道，精准找到你想看的每一部作品
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href={item.link}
              className="group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60 hover:border-primary-200 transition-all duration-300 text-center cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary-100 to-accent-100 flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className={`${item.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 font-heading">
                {item.title}
              </h3>
              <span className="text-xs text-primary-500 font-semibold mb-2 block">
                {item.count}
              </span>
              <p className="text-xs text-foreground-400 leading-relaxed">
                {item.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}